import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    input: {
      departure: "",
      destination: "",
      personsOnBoard: 0,
      fleet: undefined,
      vessel: undefined,
      vesselType: undefined,
      vesselName: "",
      vesselNo: "",
      length: 0,
      width: 0,
      draught: 0,
      height: "",
      date: new Date().toISOString(),
      speed: "",
      tonnage: 0,
      substance: "",
      amount: 0,
      classification: "",
      comment: ""
    },
    static: {
      cities: ["Vienna", "Bratislava", "Budapest", "Belgrade", "Vidin", "Ruse", "Vukovar"],
      vesselTypes: [{
        id: 1,
        name: "III",
        length: 63,
        width: 7,
        draught: 2.5,
        tonnage: 32,
        personsOnBoard: 2
      }, {
        id: 2,
        name: "Va",
        length: 110,
        width: 11.4,
        draught: 3,
        tonnage: 200,
        personsOnBoard: 3
      }, {
        id: 3,
        name: "Vb",
        length: 135,
        width: 17,
        draught: 3.5,
        tonnage: 500,
        personsOnBoard: 4
      }, {
        id: 4,
        name: "VIb",
        length: 185,
        width: 11.4,
        draught: 3.5,
        tonnage: 6000,
        personsOnBoard: 6
      }],
      vessels: [{
        id:1,
        name: "Ship 1",
        vesselType: 1,
      }, {
        id: 2,
        name: "Ship 2",
        vesselType: 1,
      }, {
        id: 3,
        name: "Ship 3",
        vesselType: 3,
      }, {
        id: 4,
        name: "Ship 4",
        vesselType: 2,
      }, {
        id: 5,
        name: "Ship 5",
        vesselType: 4,
      }, {
        id: 6,
        name: "Ship 6",
        vesselType: 2,
      }, {
        id: 7,
        name: "Ship 7",
        vesselType: 1,
      }, {
        id: 8,
        name: "Ship 8",
        vesselType: 3,
      }, {
        id: 9,
        name: "Ship 9",
        vesselType: 1,
      }, {
        id: 10,
        name: "Ship 10",
        vesselType: 2,
      }],
      fleets: [{
        name: "Fleet 1",
        vessels: [1, 2, 3]
      }, {
        name: "Fleet 2",
        vessels: [4, 5, 6]
      }, {
        name: "Fleet 3",
        vessels: [7, 8, 9, 10]
      }],
      substances:[{
        name: "Oil",
        classification: 3
      }, {
        name: "Hydrogen",
        classification: 2
      }, {
        name: "Phosphate",
        classification: 4
      }, {
        name: "Sand",
        classification: 1
      }],
      classes: [{
        id: 1,
        name: "None"
      }, {
        id: 2,
        name: "Class 2"
      }, {
        id: 3,
        name: "Class 3"
      }, {
        id: 4,
        name: "Class 8"
      }]
    }
  },
  mutations: {
    setDeparture(state, value) {
      state.input.departure = value;
    },
    setDestination(state, value) {
      state.input.destination= value;
    },
    setPersonsOnBoard(state, value) {
      state.input.personsOnBoard= value;
    },
    setFleet(state, value) {
      state.input.fleet = value;
    },
    setVessel(state, value) {
      state.input.vessel= value;
    },
    setVesselType(state, value) {
      state.input.vesselType = value;
    },
    setVesselName(state, value) {
      state.input.vesselName = value;
    },
    setVesselNo(state, value) {
      state.input.vesselNo = value;
    },
    setLength(state, value) {
      state.input.length = value;
    },
    setWidth(state, value) {
      state.input.width = value;
    },
    setDraught(state, value) {
      state.input.draught = value;
    },
    setHeight(state, value) {
      state.input.height = value;
    },
    setDate(state, value) {
      state.input.date = value;
    },
    setSpeed(state, value) {
      state.input.speed = value;
    },
    setTonnage(state, value) {
      state.input.tonnage = value;
    },
    setSubstance(state, value) {
      state.input.substance = value;
    },
    setAmount(state, value) {
      state.input.amount = value;
    },
    setClassification(state, value) {
      state.input.classification = value;
    },
    setComment(state, value) {
      state.input.comment = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
